"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3682],{

/***/ 3682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ FlightRoutePWA; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _utils_CommonUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4250);
/* harmony import */ var html_react_parser__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7311);
/* eslint-disable react/no-danger */ 



function FlightRoutePWA(props) {
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (language && language === "ar") document.body.classList.add("isArabic");
        else {
            document.body.classList.add("bodyClass");
            document.body.id = "cmsintlflt";
            document.body.setAttribute("data-domain", "www_intl_flight_makemytrip_com");
        }
    });
    var ref = props === null || props === void 0 ? void 0 : props.data, language = ref.language, contentBottom = ref.contentBottom, contentTop = ref.contentTop, contentMiddle = ref.contentMiddle, top_overlay = ref.top_overlay, leftBlock = ref.leftBlock, rightBlock = ref.rightBlock, bottomBlock = ref.bottomBlock, tmp = ref.initial_js, initialJS = tmp === void 0 ? "" : tmp, mainDiv = ref.main_div, appConfig = ref.appConfig, ccde = ref.ccde, _isGoibibo = ref.isGoibibo, isGoibibo = _isGoibibo === void 0 ? false : _isGoibibo;
    var jsPath;
    var cssPath;
    if (appConfig === null || appConfig === void 0 ? void 0 : appConfig.liveMode) {
        jsPath = "https://jsak.mmtcdn.com/flights-cms-seo/assets/_next/static/js";
        cssPath = "https://jsak.mmtcdn.com/flights-cms-seo/assets/_next/static/css";
    } else {
        jsPath = "http://localhost:3000/_next/static/js";
        cssPath = "http://localhost:3000/_next/static/css";
    }
    var intentOfferOverlayCSSPath = "".concat(cssPath, "/intentOfferOverlay.min.css");
    var intentOfferOverlayJSPath = "".concat(jsPath, "/intentOffer.min.js");
    var googleTagId = isGoibibo ? "GTM-5VDCXLQ" : "GTM-NWV3K7C";
    var googletTagString = "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n  new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n  'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n  })(window,document,'script','dataLayer','".concat(googleTagId, "');\n");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            initialJS && initialJS !== "" ? (0,html_react_parser__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(initialJS) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                dangerouslySetInnerHTML: {
                    __html: mainDiv
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "fli-intl-container prepend_top20 clearfix",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "fli-intl-lhs pull-left",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "seoOnlyBlock col-lg-9 col-md-12 col-sm-12 col-xs-12",
                            children: [
                                (0,_utils_CommonUtils__WEBPACK_IMPORTED_MODULE_2__/* .transformToHtml */ .cR)(contentTop),
                                (0,_utils_CommonUtils__WEBPACK_IMPORTED_MODULE_2__/* .transformToHtml */ .cR)(contentMiddle),
                                (0,_utils_CommonUtils__WEBPACK_IMPORTED_MODULE_2__/* .transformToHtml */ .cR)(contentBottom),
                                (0,_utils_CommonUtils__WEBPACK_IMPORTED_MODULE_2__/* .transformToHtml */ .cR)(bottomBlock)
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "seoOnlyBlock col-lg-3 col-md-12 col-sm-12 col-xs-12",
                            children: [
                                (0,_utils_CommonUtils__WEBPACK_IMPORTED_MODULE_2__/* .transformToHtml */ .cR)(leftBlock),
                                (0,_utils_CommonUtils__WEBPACK_IMPORTED_MODULE_2__/* .transformToHtml */ .cR)(rightBlock)
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                dangerouslySetInnerHTML: {
                    __html: top_overlay
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "overlay_hamburger"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                id: "back-top",
                className: "back-to-top",
                children: "\xa0"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                href: "".concat(intentOfferOverlayCSSPath),
                rel: "stylesheet"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                defer: true,
                type: "text/javascript",
                src: "".concat(intentOfferOverlayJSPath)
            }),
            ccde && (ccde === "" || ccde === "in" || ccde === "IN") ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                dangerouslySetInnerHTML: {
                    __html: googletTagString
                }
            }) : null
        ]
    });
}


/***/ })

}]);